export const getLanguage = (): string => {
  const language = (window.localStorage.i18nextLng || 'de')
    .split('-')[0]
    ?.toLowerCase();
  const isCountryNameLanguages = ['en', 'de', 'pl'].includes(language);
  return isCountryNameLanguages ? language : 'de';
};
